import { render, staticRenderFns } from "./register_serial.vue?vue&type=template&id=1ada8e68&scoped=true&"
import script from "./register_serial.vue?vue&type=script&lang=js&"
export * from "./register_serial.vue?vue&type=script&lang=js&"
import style0 from "./register_serial.vue?vue&type=style&index=0&id=1ada8e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada8e68",
  null
  
)

export default component.exports